import root from '../../index';
import { isStorageAvailable } from '../../utils';
import { setCustomData } from '../../analytics';

import './index.scss';

const STORAGE_AVAILABLE = isStorageAvailable()

function main() {
  root(true)
  setCustomData('emprestimo-sem-comprovacao-de-rend', 'conteudo interno')
}

main()



// WEBPACK FOOTER //
// ./src/pages/unsecured_loan/index.js